import * as React from 'react'
import FoundHoursOverview from "./FoundHoursOverview";
import { FoundHourShape } from '../../api/api_data_types'
type FoundHoursOverviewAppProps = {
  foundHours: FoundHourShape[]
}

export default function FoundHoursOverviewApp({ foundHours }: FoundHoursOverviewAppProps) {
  return <FoundHoursOverview foundHours={foundHours} />
}
